export const FileData = {
    extension: true,
    filename: true,
    height: true,
    id: true,
    mime: true,
    niceSize: true,
    template: true,
    type: true,
    url: true,
    width: true,
}
export const topicQuery = {
    title: true,
    slug: true,
    uuid: "page.uuid",
    primary_image: true,
    hover_image: true,
}
export const blockSelectQueries = {
    heroSlider: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            auto_swipe: true,
            swipe_timeout: true,
            slides: {
                query: "structureItem.slides.toStructure",
                select: {
                    background_image: true,
                    background_video: true,
                    uses_video: true,
                    tag: true,
                    topics_reference: true,
                    title: true,
                    subtitle: true,
                    description: true,
                    page_reference: true,
                    inactive: true,
                    disable_primary: true,
                    secondary_links: {
                        query: "structureItem.secondary_links.toStructure",
                        select: {
                            link: true,
                            text: true,
                            target: true,
                        },
                    },
                },
            },
        },
    },
    image: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            anchor: true,
            img: true,
            img_caption: true,
            img_link: true,
        },
    },
    video: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            subtitle: true,
            video_file: true,
            video_caption: true,
            video_cover_img: true,
        },
    },
    splittedHeroRow: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            background_image: true,
            background_video: true,
            uses_video: true,
            tag: true,
            topics_reference: true,
            subtitle: true,
            description: true,
            page_reference: true,
            inactive: true,
            disable_primary: true,
            secondary_links: {
                query: "structureItem.secondary_links.toStructure",
                select: {
                    link: true,
                    text: true,
                    target: true,
                },
            },
            secondary: {
                query: "structureItem.secondary.toStructure",
                select: {
                    background_image: true,
                    background_video: true,
                    uses_video: true,
                    tag: true,
                    topics_reference: true,
                    title: true,
                    subtitle: true,
                    description: true,
                    page_reference: true,
                    inactive: true,
                    disable_primary: true,
                    secondary_links: {
                        query: "structureItem.secondary_links.toStructure",
                        select: {
                            link: true,
                            text: true,
                            target: true,
                        },
                    },
                },
            },
        },
    },
    articlesPreview: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            direction: true,
            homepage_mode: true,
            manual_selection: true,
            articles: {
                query: "structureItem.articles.toStructure",
                select: {
                    article_page: true,
                    is_primary: true,
                    related_persons: true,
                },
            },
            sticky_header_title: true,
            page_reference: true,
            article_types: true,
            main_article_page: true,
        },
    },
    peopleSlider: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            description: true,
            slides: {
                query: "structureItem.slides.toStructure",
                select: {
                    desktop_image: true,
                    mobile_image: true,
                    name: true,
                    description: true,
                },
            },
        },
    },
    skewedImageSlider: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            slides: {
                query: "structureItem.slides.toStructure",
                select: {
                    pretitle: true,
                    title: {
                        query: "structureItem.title.toStructure",
                        select: {
                            part1: true,
                            emphasized: true,
                            part2: true,
                        },
                    },
                    description: true,
                    page_reference: true,
                    background_image: true,
                },
            },
        },
    },
    articleFilter: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            filtertype: true,
        },
    },
    articleLink: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            article_page: true,
        },
    },
    blackTextBlock: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            text: true,
        },
    },
    creditFooterRow: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            text: true,
            persons: true,
        },
    },
    currentNavigation: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
        },
    },
    grayTextBlocks: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            texts: {
                query: "structureItem.texts.toStructure",
                select: {
                    text: true,
                },
            },
        },
    },
    keypoints: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            keypoints: {
                query: "structureItem.keypoints.toStructure",
                select: {
                    keypoint: true,
                },
            },
        },
    },
    personCards: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            persons: true,
        },
    },
    personSmallPreviewCards: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            persons: true,
        },
    },
    text: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            text: true,
            skewedquotetoggle: true,
            skewedquote: true,
        },
    },
    downloadablePreviewCard: {
        type: true,
        content: {
            hastitle: true,
            titletype: true,
            titlemargin: true,
            title: true,
            "margin-top": true,
            "margin-bottom": true,
            title_preview_card: true,
            description: true,
            file: true,
            preview_image: true,
        },
    },
}

export function getPageSelect(pageType?: string): any {
    const commonPageFields: KQLSelect = {
        children: true,
        drafts: true,
        files: true,
        id: true,
        intendedTemplate: true,
        isHomePage: true,
        isErrorPage: true,
        num: true,
        template: true,
        title: true,
        slug: true,
        status: true,
        uid: true,
        url: true,
    }

    let contentSelect = {
        meta_title: true,
        meta_description: true,
        meta_canonical: true,
        meta_noindex: true,
        meta_nofollow: true,
        meta_img: true,
        meta_hidden_content: true,
        no_en_version: true,
        uuid: true,
    }

    const main_layout = {}

    const ContentPageSelect = {
        hero_row_toggle: true,
        sticky_title_header_toggle: true,
        sticky_title_header: true,
        bottom_content_toggle: true,

        // layout blöcke lassen sich nicht via select filtern - kirby unterstützt das nicht - , da sie zu komplex werden können
        main_layout: main_layout,
        sticky_upper_layout: main_layout,
        sticky_lower_layout: main_layout,
        bottom_content: main_layout,
        hero_row: main_layout,
    }

    return {
        ...commonPageFields,
        ...contentSelect,

        title: true,
        url: true,

        //person
        person_role: true,
        preview_img: true,
        person_email: true,
        person_phones: true,
        person_name: true,
        person_academic_titles: true,
        allow_search: true,
        redirect_to_parent: true,
        no_profile: true,
        department: true,
        person_phone: true,
        person_telefax: true,
        person_links: {
            query: "page.person_links.toStructure()",
            select: {
                url: true,
                title: true,
                type: true,
            },
        },

        //article entry
        background_image: true,
        hover_preview_image: true,
        tag: true,
        topics_reference: true,
        inactive: true,
        subtitle: true,
        description: true,
        publication_date: true,
        person_reference: true,
        eventseries_reference: true,
        eventlocation_reference: true,
        secondary_links: true,
        disable_primary: true,
        type: true,
        is_event: true,
        is_vlog: true,

        //articles
        articles: true,

        //topics
        primary_image: true,
        ...ContentPageSelect,
    }
}
